import {IAbstractModule, IModuleType} from "@/model/Locker/IModule";

export const ModuleZMixA: IAbstractModule = {
  type: IModuleType.mixZ,
  name: 'Z Mix A (1-8)',
  hasScreen: false,
  columns: [
    [
      {
        name: "1",
        connector: "1",
        cell_size_id: 1,
        accessible: false,
      },
      {
        name: "2",
        connector: "2",
        cell_size_id: 3,
        accessible: false,
      },
      {
        name: "3",
        connector: "3",
        cell_size_id: 3,
        accessible: false,
      },
      {
        name: "4",
        connector: "4",
        cell_size_id: 3,
        accessible: true,
      },
      {
        name: "5",
        connector: "5",
        cell_size_id: 3,
        accessible: true,
      },
      {
        name: "6",
        connector: "6",
        cell_size_id: 3,
        accessible: true,
      },
      {
        name: "7",
        connector: "7",
        cell_size_id: 3,
        accessible: true,
      },
      {
        name: "8",
        connector: "8",
        cell_size_id: 4,
        accessible: false,
      },
    ],
  ]
};
